var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManageAccounts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#444d63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 21H30a1 1 0 00-1 1v24a1 1 0 001 1h16a1 1 0 001-1V22a1 1 0 00-1-1zm-5 20h-6a1 1 0 110-2h6a1 1 0 110 2zm0-6h-6a1 1 0 110-2h6a1 1 0 110 2zm0-6h-6a1 1 0 110-2h6a1 1 0 110 2z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    d: "M36 5H25V2a1 1 0 10-2 0v3H12a1 1 0 00-1 1v19h8a2 2 0 012 2v20h6V21a2 2 0 012-2h8V6a1 1 0 00-1-1zm-8 10h-8a1 1 0 110-2h8a1 1 0 110 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 27H2a1 1 0 00-1 1v18a1 1 0 001 1h16a1 1 0 001-1V28a1 1 0 00-1-1zm-5 14H7a1 1 0 110-2h6a1 1 0 110 2zm0-6H7a1 1 0 110-2h6a1 1 0 110 2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageAccounts);
export default __webpack_public_path__ + "static/media/manage-accounts.bd9f805c.svg";
export { ForwardRef as ReactComponent };